<script setup>
import Close from 'assets/icons/close.svg'
import { useSideBarStore } from '~/stores/sideBar'

// Global
const { toggleSideBarLayer } = useSideBarStore()

const closeOnBoarding = () => {
    toggleSideBarLayer(false)
}
</script>

<template>
    <div class="side-bar-onboarding">
        <div class="side-bar-onboarding-container">
            <div class="close-sidebar" @click="closeOnBoarding()">
                <Close />
            </div>
            <slot />
        </div>
    </div>
</template>

<style lang="scss">
.side-bar-onboarding {
    background: $side-bar-onboarding-layer;
    position: fixed;
    inset: 0;
    z-index: z('side-bar-onboarding-layer');
}

.side-bar-onboarding-container {
    animation: slide-in 0.6s ease-in-out forwards;
    width: 100vw;
    max-width: 500px;
    background: $sidebar-content-bg;
    box-shadow: 20px 20px 40px $sidebar-content-shadow;
    position: fixed;
    z-index: z('side-bar-onboarding');
    top: 0;
    right: 0;
    bottom: 0;

    @include scrollbar;
}

@keyframes slide-in {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0);
    }
}
</style>
